package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.Serializable

@Serializable
data class AssetRequest(
    val id: String,
    val prompt: String,
    val type: AssetType,
    val metadata: Map<String, String> = emptyMap(),
    val timestamp: Long = 0L,
    val referenceImages: List<String> = emptyList()
)
